import ConfigData from 'config/ConfigData';

const getEmbargoStatusOptions = () => [
  { name: 'All updates' },
  {
    name: 'Currently embargoed',
    filter: [{ field: 'embargoed', value: 'true', operator: 'str_eq' }],
  },
];

const KeyUpdatesFilters = [
  {
    name: 'Embargo status',
    type: 'singleSelect',
    searchState: 'embargoStatusEnabledCondition',
    pages: ['KeyUpdates'],
    filterName: 'embargoStatus',
    optionSelected: 'All updates',
    emptyOptionName: 'All updates',
    configHidden: ConfigData?.filters?.embargoStatus?.configHidden,
    customOrder: 0,
    options: getEmbargoStatusOptions(),
  },
  {
    name: 'Embargo status',
    type: 'singleSelect',
    searchState: 'embargoStatusDisabledCondition',
    disabled: true,
    lockMessage: 'Upgrade to our Enterprise plan to access<br /> news under embargo when available',
    pages: ['KeyUpdates'],
    filterName: 'embargoStatus',
    optionSelected: 'All updates',
    emptyOptionName: 'All updates',
    configHidden: ConfigData?.filters?.embargoStatus?.configHidden,
    customOrder: 0,
    options: getEmbargoStatusOptions().map((option) => ({ ...option, disabled: true })),
  },
  {
    type: 'membership',
    subtype: 'usStateOptions',
    prefix: 'state',
    name: 'State',
    pages: ['KeyUpdates'],
    filterName: 'region',
    optionSelected: '',
    options: [],
    configHidden: ConfigData?.filters?.state?.configHidden,
  },
  {
    name: 'Publisher type',
    searchState: 'always',
    pages: ['KeyUpdates'],
    filterName: 'tags',
    // Only bypasses default tags config for URL hash encoding/normalization; tag UI/behavior still uses filterName: 'tags'.
    notUseTagsConfig: true,
    configHidden: ConfigData?.filters?.newsPublisherType?.configHidden,
    options: [
      {
        name: 'U.S. executive branch agency',
      },
      {
        name: 'U.S. judicial branch agency',
      },
      {
        name: 'Congressional office',
      },
      {
        name: 'Military',
      },
      {
        name: 'State agency',
      },
      {
        name: 'Local/regional agency',
      },
    ],
  },
];

export default KeyUpdatesFilters;
